import {
  Button,
  CheckBox,
  DatePicker,
  Icon,
  RaytebForm,
  Select,
  TextBox,
  TypeaheadText,
} from '../../share/Elements'
import { TextBoxTypeEnum } from '../../enums/TextBoxTypeEnum'
import {
  Collapse,
  DeserveModal,
  GetForUnRegisterUserModal,
  LoadingFit,
  MenuFooter,
  NewAppointmentModal,
  PageHeader,
  PartialDeserveModal,
  QueueInfoModal,
} from '../../share/Components'
import { AppointmentCard } from '../../share/Components'
import { GenderEnum } from '../../enums/GenderEnum'
import { useState, useEffect, ReactElement, useRef } from 'react'
import classes from './Appointment.module.scss'
import {
  DeserveModalInterface,
  PartialDeserveModalInterface,
} from '../../Interfaces/DeserveModalInterface'
import {
  AppointmentCardInterface,
  ListAppointmentCardInterface,
} from '../../Interfaces/AppointmentCardInterface'
import { NewAppointmentModalInterface } from '../../Interfaces/NewAppointmentModalInterface'
import useFetch from '../../_services/fetch'
import { RaytebRequests } from '../../_services'
import { useDispatch, useSelector } from 'react-redux'
import { LoginInterface } from '../../Interfaces/LoginInterface'
import { ReducerType } from '../../storeManager/ReducerType'
import {
  insertPatient,
  insertPatientCalled,
  pushPatientAbsent,
  pushPatientCalled,
} from '../../storeManager/Reducers/appoinemntsSlice'
import { useNavigate } from 'react-router-dom'
import { CenterConfigEnum } from '../../enums/CenterConfig'
import {
  setQueueRoom,
  setQueueTicket,
} from '../../storeManager/Reducers/queueSlice'
import { toast } from 'react-toastify'
import Debounce from '../../share/Elements/Textboxs/Debounce'
import HelTag from 'react-helmet'
import useSocket from '../../_services/socket'
import { QueueStateEnum } from '../../enums/QueueStateEnum'
import { AppointmentCardViewModel } from '../../models/ViewModels/AppointmentCardViewModel'
import Skeleton from 'react-loading-skeleton'
import { DoctorShiftType } from '../../share/Components/Modal/NewAppointmentModal'
import { JitsiMeeting } from '@jitsi/react-sdk'
import { GetForUnRegisterUserInderface } from '../../Interfaces/GetForUnRegisterUserInderface'

const Appointment = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [searchAppointment, setSearchAppointment] = useState<Array<string>>([
    '',
  ])
  const appointments = useSelector<ReducerType, ListAppointmentCardInterface>(
    (state) => state.reducerAppointment
  )
  const [showjitsi, setShowJitsi] = useState<boolean>(false)

  const [showingPatient, setShowingPatient] = useState(false)
  const [vistiDate, setVisitDate] = useState<Date>(new Date());
  const device = useSelector<ReducerType, DeviceModeInterface>(
    (state) => state.reducerDevice
  )
  const queue = useSelector<ReducerType, QueueViewModel>(
    (state) => state.reducerQueue
  )

  const [deserveModal, setDeserveModal] = useState<DeserveModalInterface>({
    isOpen: false,
    data: undefined,
    showFooter: false,
    hideModal() {
      setDeserveModal({ ...deserveModal, isOpen: false })
    },
    onAdded(prescription, shift) {
      // const patient = prescription.patient
      // dispatch(
      //   insertPatient({
      //     appointments: [
      //       ...appointments.appointments,
      //       {
      //         firstName: patient?.firstName,
      //         lastName: patient?.lastName,
      //         age: patient?.age,
      //         birthDate: patient?.birthDate,
      //         code: patient?.code,
      //         mobile: patient?.mobile,
      //         isVisit: false,
      //         gender: patient?.gender ? GenderEnum[patient?.gender] : 'نامشخص',
      //         imageUrl: patient?.imageUrl,
      //         ticketId: prescription.ticketId,
      //         insuranceBoxTitle: patient?.insuranceBoxTitle,
      //       },
      //     ],
      //     shift: shift,
      //     dateMiladi: prescription?.date,
      //     dateShamsi: new Date(prescription?.date!).toShamsi(),
      //   })
      // )
      deserveModal.hideModal?.()
      appointmentList.reFetch({
        date: vistiDate,
        doctorServeShift: appointments.doctorServeShift,
        showPayed: appointments.showPayed ?? false,
        showReception: appointments.showReception ?? false,
        showVisit: appointments.showVisit ?? false,
        skip: 0,
        take: 100,
      })
      // if (center.hasRecord) navigate('/prescription/record')
      // else navigate('/prescription/newPrescription')
    },
  })

  const [partialDeserveModal, setPartialDeserveModal] =
    useState<PartialDeserveModalInterface>({
      isOpen: false,
      data: undefined,
      showFooter: false,
      hideModal() {
        setPartialDeserveModal({ ...partialDeserveModal, isOpen: false })
      },
      onAdded(prescription, shift) {
        // const patient = prescription.patient
        // dispatch(
        //   insertPatient({
        //     appointments: [
        //       ...appointments.appointments,
        //       {
        //         firstName: patient?.firstName,
        //         lastName: patient?.lastName,
        //         age: patient?.age,
        //         birthDate: patient?.birthDate,
        //         code: patient?.code,
        //         mobile: patient?.mobile,
        //         isVisit: false,
        //         gender: patient?.gender
        //           ? GenderEnum[patient?.gender]
        //           : 'نامشخص',
        //         imageUrl: patient?.imageUrl,
        //         ticketId: prescription.ticketId,
        //       },
        //     ],
        //     shift: shift,
        //     dateMiladi: prescription?.date,
        //     dateShamsi: new Date(prescription?.date!).toShamsi(),
        //   })
        // )
        partialDeserveModal.hideModal?.()
        appointmentList.reFetch({
          date: vistiDate,
          doctorServeShift: appointments.doctorServeShift,
          showPayed: appointments.showPayed ?? false,
          showReception: appointments.showReception ?? false,
          showVisit: appointments.showVisit ?? false,
          skip: 0,
          take: 100,
        })
        // if (center.hasRecord) navigate('/prescription/record')
        // else navigate('/prescription/newPrescription')
      },
    })

  const [getForUnRegisterUserModal, setGetForUnRegisterUserModal] =
    useState<GetForUnRegisterUserInderface>({
      isOpen: false,
      data: undefined,
      showFooter: false,
      ticketId: null,
      hideModal() {
        setGetForUnRegisterUserModal({ ...getForUnRegisterUserModal, isOpen: false })
      },
      onAdded(prescription, shift) {
        debugger
        if (center.hasRecord) navigate('/prescription/record')
        else navigate('/prescription/newPrescription')
      },
    })
  const [newAppointment, setNewAppointment] =
    useState<NewAppointmentModalInterface>({
      setDeserveModal,
      setPartialDeserveModal: setPartialDeserveModal,
      isOpen: false,
      deserveModal,
      partialDeserveModal,
      hideModal() {
        setNewAppointment({ ...newAppointment, isOpen: false })
      },
    })

  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const jitsiRef = useRef<HTMLDivElement>()

  const setMeetingRequest = useFetch<unknown, SetMeetingInterface>({
    request: RaytebRequests.Appointment_SetMeeting_POST({ token: user.token!, headers: { centerId: center.id } }),
    onSuccess(data) {
      if (setMeetingRequest.payLoad?.isJoin)
        setShowJitsi(true)
      else
        setShowJitsi(false)

    },
  })
  const [doctorServeShift, setDoctorServeShift] = useState<
    DoctorShiftType | undefined
  >({})
  const doctorServeShifts = useFetch<Array<DoctorShiftType>>({
    request: RaytebRequests.Doctor_DoctorServeShifts_GET({
      centerId: center.id,
      token: user.token!,
    }),
    fetchInitialLoad: true,
  })

  const isEnableQueue =
    center.centerConfigs?.find((n) => n.key === CenterConfigEnum.Queue)
      ?.value === 'True'

  const statisticsAppointment = useFetch<
    { totalVisited: number, totalComplete: number, totalPayed: number, totalAll: number },
    {
      date: Date | undefined
      doctorServeShift: string | undefined
    }
  >({
    request: RaytebRequests.StatisticsAppointment_POST({
      headers: { centerId: center.id },
      token: user?.token,
    }),
  });

  const appointmentList = useFetch<
    Array<AppointmentCardInterface>,
    AppointmentListInputModel
  >({
    request: RaytebRequests.Appointment_List_POST({
      headers: { centerId: center.id },
      token: user?.token,
    }),
    onSuccess(data) {
      if (isEnableQueue) {
        const list = data?.filter(
          (n) =>
            n.queueState === "" || QueueStateEnum[n.queueState!] === QueueStateEnum.Waiting || QueueStateEnum[n.queueState!] === QueueStateEnum.TransfredToAnotherQueue
        ).sort((a, b) => (a.isVisit! > b.isVisit!) ? 1 : ((b.isVisit! > a.isVisit!) ? -1 : 0))
        const listCalled = data?.filter(
          (n) =>
            n.queueState !== "" && QueueStateEnum[n.queueState!] !== QueueStateEnum.Waiting && QueueStateEnum[n.queueState!] !== QueueStateEnum.TransfredToAnotherQueue
        )
        dispatch(
          insertPatient({
            appointments: list,
            doctorServeShift: appointmentList.payLoad?.doctorServeShift,
            dateMiladi: appointmentList.payLoad?.date,
            dateShamsi: appointmentList.payLoad?.date
              ? new Date(appointmentList.payLoad?.date!).toShamsi()
              : '',
            showReception: appointmentList.payLoad?.showReception,
            showPayed: appointmentList.payLoad?.showPayed,
            showVisit: appointmentList.payLoad?.showVisit,
          })
        )
        dispatch(
          insertPatientCalled({
            appointmentCalled: listCalled ?? [],
            doctorServeShift: appointmentList.payLoad?.doctorServeShift,
            dateMiladi: appointmentList.payLoad?.date,
            dateShamsi: appointmentList.payLoad?.date
              ? new Date(appointmentList.payLoad?.date!).toShamsi()
              : '',
            showReception: appointmentList.payLoad?.showReception,
            showPayed: appointmentList.payLoad?.showPayed,
            showVisit: appointmentList.payLoad?.showVisit,
          })
        )
      } else {
        dispatch(
          insertPatient({
            appointments: data.sort((a, b) => (a.isVisit! > b.isVisit!) ? 1 : ((b.isVisit! > a.isVisit!) ? -1 : 0)),
            doctorServeShift: appointmentList.payLoad?.doctorServeShift,
            dateMiladi: appointmentList.payLoad?.date,
            dateShamsi: appointmentList.payLoad?.date
              ? new Date(appointmentList.payLoad?.date!).toShamsi()
              : '',
            showReception: appointmentList.payLoad?.showReception,
            showPayed: appointmentList.payLoad?.showPayed,
            showVisit: appointmentList.payLoad?.showVisit,
          })
        )
        dispatch(
          insertPatientCalled({
            appointmentCalled: [],
            doctorServeShift: appointmentList.payLoad?.doctorServeShift,
            dateMiladi: appointmentList.payLoad?.date,
            dateShamsi: appointmentList.payLoad?.date
              ? new Date(appointmentList.payLoad?.date!).toShamsi()
              : '',
            showReception: appointmentList.payLoad?.showReception,
            showPayed: appointmentList.payLoad?.showPayed,
            showVisit: appointmentList.payLoad?.showVisit,
          })
        )
      }

      statisticsAppointment.reFetch({
        date: vistiDate,
        doctorServeShift: appointments.doctorServeShift
      })
    },
    onStatusCode400(data) {
      dispatch(
        insertPatient({
          appointments: [],
          doctorServeShift: null,
          dateMiladi: new Date(),
          dateShamsi: new Date().toShamsi(),
          showReception: appointments?.showReception,
          showPayed: appointments?.showPayed,
          showVisit: appointments?.showVisit,
        })
      )
      dispatch(
        insertPatientCalled({
          appointmentCalled: [],
          doctorServeShift: null,
          dateMiladi: new Date(),
          dateShamsi: new Date().toShamsi(),
          showReception: appointments?.showReception,
          showPayed: appointments?.showPayed,
          showVisit: appointments?.showVisit,
        })
      )
    },
  })

  const [showFilter, setShowFilter] = useState<boolean>(true)
  const [showQueueInfoModal, setShowQueueInfoModal] = useState<boolean>(false)
  const queueCall = useFetch<
    unknown,
    unknown,
    { ticketId: string; room: number }
  >({
    request: RaytebRequests.Queue_Call_POST({
      headers: { centerId: center.id },
      token: user?.token,
    }),
    onSuccess(data) { },
  })
  const queueAbsent = useFetch<
    unknown,
    unknown,
    { ticketId: string; room: number }
  >({
    request: RaytebRequests.Queue_Absent_POST({
      headers: { centerId: center.id },
      token: user?.token,
    }),
    onSuccess(data) { },
  })

  const addorUpdateAppointment = (data: AppointmentCardViewModel) => {
    // if (
    //   appointments?.dateShamsi === new Date(data.visitDate!).toShamsi() &&
    //   (!appointments.doctorServeShift ||
    //     appointments?.doctorServeShift === data.doctorServeShift) &&
    //   center.id == data.centerId
    // ) {
    //   if (
    //     ![...appointments.appointments, ...appointments.appointmentCalled].some(
    //       (n) => n.ticketId === data.ticketId
    //     )
    //   )
    //     dispatch(
    //       insertPatient({
    //         ...appointments,
    //         appointments: [...appointments.appointments, data],
    //       })
    //     )
    //   else if (
    //     !appointments.doctorServeShift ||
    //     appointments.doctorServeShift === data.doctorServeShift
    //   ) {
    //     const list = [...appointments.appointments]
    //     const index = list.findIndex((n) => n.ticketId === data.ticketId)
    //     list[index] = data
    //     dispatch(
    //       insertPatient({
    //         ...appointments,
    //         appointments: list,
    //       })
    //     )
    //   }
    // }
    appointmentList.reFetch(appointmentList.payLoad)
  }

  const deleteAppointment = (data: DeleteAppointmnetViewModel) => {
    const listAppointment = [...appointments.appointments]?.filter(
      (n) => n.ticketId !== data.ticketId
    )
    const listAppointmentCalled = [...appointments.appointmentCalled]?.filter(
      (n) => n.ticketId !== data.ticketId
    )
    dispatch(
      insertPatient({
        ...appointments,
        appointments: listAppointment,
      })
    )
    dispatch(
      insertPatientCalled({
        ...appointments,
        appointmentCalled: listAppointmentCalled ?? [],
      })
    )
    statisticsAppointment.reFetch({
      date: vistiDate,
      doctorServeShift: appointments.doctorServeShift
    })
  }
  const socket = useSocket({
    controllerName: 'appointment',
    token: `${user.token!}`,
    ReciveMethods: {
      methods: [
        {
          name: 'deleteAppointment',
          onRecived: (data) => deleteAppointment(data),
        },
        {
          name: 'newAppointment',
          onRecived: (data) => addorUpdateAppointment(data),
        },
      ],
      dependencies: [appointments],
    },
  })

  useEffect(() => {
    appointmentList.reFetch({
      date: vistiDate,
      doctorServeShift: appointments.doctorServeShift,
      showPayed: appointments.showPayed ?? false,
      showReception: appointments.showReception ?? false,
      showVisit: appointments.showVisit ?? false,
      skip: 0,
      take: 100,
    })
    doctorServeShifts.reFetch()
  }, [center?.id])


  return (
    <>
      <HelTag>
        <title>نوبت ها</title>
      </HelTag>
      <PageHeader title='نوبت های امروز' />
      {showjitsi ? <JitsiMeeting

        domain={'telme.rayteb.ir'}
        onReadyToClose={() => {
          setMeetingRequest.reFetch({ patientCode: setMeetingRequest.payLoad?.patientCode!, ticketId: setMeetingRequest.payLoad?.ticketId!, isJoin: false })
        }}

        roomName={setMeetingRequest.payLoad?.ticketId!}
        getIFrameRef={(x) => {
          x.style.display = 'block'
          x.style.position = 'fixed'
          x.style.width = '100%'
          x.style.height = '100%'
          x.style.zIndex = '999999'
          x.style.top = '0'
          x.style.left = '0'
          jitsiRef.current = x
        }}
        configOverwrite={{
          doNotStoreRoom: false,
          enableWelcomePage: true,
          prejoinPageEnabled: false,
          remoteVideoMenu: {
            disableKick: false
          },
        }}
        interfaceConfigOverwrite={{
          SHOW_WATERMARK_FOR_GUESTS: false,
          DEFAULT_REMOTE_DISPLAY_NAME: 'New User',
          TOOLBAR_BUTTONS: ['hangup', 'microphone', 'camera', 'tileview', 'desktop', 'settings'],
        }}
        onApiReady={(api) => {
        }}
      /> : <></>}
      <LoadingFit isLoading={queueCall.isLoading || queueAbsent.isLoading || appointmentList.isLoading} />
      {device.Desktop || device.Laptop ? (
        <Collapse
          index={showFilter}
          onClick={() => setShowFilter(!showFilter)}
          title='فیلتر و جستجو'
          icon='rayteb-filter-b'
          className={{
            className: 'bg-secondaryLight rounded-b-xl',
            iconClass: 'text-warn',
            titleClass: 'text-white',
          }}
          isShow={true}
          element={
            <RaytebForm
              checkIsRequired={true}
              className='relative md:max-w-md md:mx-auto'
              onSubmit={(e) => {
                appointmentList.reFetch({
                  date: new Date(e.target['Date'].getAttribute('rayteb-value')),
                  doctorServeShift: doctorServeShift?.key!,
                  showPayed: e.target['showPayed'].checked,
                  showReception: e.target['showReception'].checked,
                  showVisit: e.target['showVisit'].checked,
                  skip: 0,
                  take: 100,
                })
              }}
            >
              <div className={classes['filter-row']}>
                <div className='col-span-7'>
                  {!doctorServeShifts.isLoading &&
                    doctorServeShifts.result &&
                    doctorServeShifts.result?.length !== 0 ? (
                    <TypeaheadText<DoctorShiftType>
                      innerText='شیفت / خدمت'
                      className='w-full h-9'
                      listData={[
                        { key: null, value: 'همه' },
                        ...doctorServeShifts.result!,
                      ]}
                      fieldItem='value'
                      fieldValue='key'
                      value={doctorServeShifts.result?.find(
                        (n) => n.key === appointments.doctorServeShift
                      )}
                      selected={(e) => {
                        setDoctorServeShift(e)
                        setTimeout(() => {
                          document.getElementById('submitForm')?.click()
                        }, 300)
                      }}
                    ></TypeaheadText>
                  ) : (
                    <>
                      {doctorServeShifts.isLoading ? (
                        <Skeleton className='!w-full h-9 rounded-lg' />
                      ) : (
                        <Select className='w-full h-9'>
                          <option value={''}>همه (شیفت / خدمت)</option>
                        </Select>
                      )}
                    </>
                  )}
                </div>
                <div className='col-span-3'>
                  <DatePicker
                    onChange={(e) => {
                      document.getElementById('submitForm')?.click()
                      setVisitDate(new Date(e.target.valueMiladi))
                    }}
                    innerText='تاریخ'
                    isRequired={true}
                    className='h-7 w-full'
                    name='Date'
                    value={appointments.dateShamsi || new Date().toShamsi()}
                    raytebValue={appointments.dateMiladi || new Date()}
                  />
                </div>
              </div>
              <div className={classes['filter-row']}>
                {center.centerConfigs?.find(
                  (n) => n.key === CenterConfigEnum.Queue
                )?.value === 'True' ? (
                  <>
                    <div className='col-span-6'>
                      <TextBox
                        debounceTime={0}
                        className='w-full h-8 '
                        innerText='جستجوی نام و نام خانوادگی ، کد ملی'
                        Type={TextBoxTypeEnum.Text}
                        onChange={(e) => {
                          const arr = e.target.value
                            .split(' ')
                            .map((n) => n.replace(' ', ''))
                          setSearchAppointment(arr)
                        }}
                      />
                    </div>
                    <div className='col-span-4 flex justify-center items-center gap-2'>
                      <TextBox
                        className=''
                        Type={TextBoxTypeEnum.Number}
                        innerText='شماره اتاق'
                        isReadOnly={true}
                        value={queue.roomNo?.toString()}
                      />
                      <Icon
                        icon='rayteb-edit'
                        className='text-xl text-warn'
                        onClick={() => {
                          setShowQueueInfoModal(true)
                        }}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className='col-span-9'>
                      <TextBox
                        debounceTime={0}
                        className='w-full h-8 '
                        innerText='جستجوی نام و نام خانوادگی ، کد ملی'
                        Type={TextBoxTypeEnum.Text}
                        onChange={(e) => {
                          const arr = e.target.value
                            .split(' ')
                            .map((n) => n.replace(' ', ''))
                          setSearchAppointment(arr)
                        }}
                      />
                    </div>
                  </>
                )}
              </div>
              <div className={classes['filter-row-checkbox']}>
                <CheckBox
                  onChange={(e) =>
                    document.getElementById('submitForm')?.click()
                  }
                  lable='پذیرش'
                  className='text-xs !font-bold'
                  name='showReception'
                  checked={appointments.showReception}
                />
                <CheckBox
                  onChange={(e) =>
                    document.getElementById('submitForm')?.click()
                  }
                  lable='پرداخت'
                  className='text-xs !font-bold'
                  name='showPayed'
                  checked={appointments.showPayed}

                />
                <CheckBox
                  onChange={(e) =>
                    document.getElementById('submitForm')?.click()
                  }
                  lable='ویزیت'
                  className='text-xs !font-bold'
                  name='showVisit'
                  checked={appointments.showVisit}
                />
                {/* <CheckBox
                  onChange={(e) =>
                    document.getElementById('submitForm')?.click()
                  }
                  lable='مشاوره'
                  className='text-xs !font-bold'
                /> */}
              </div>
              <input
                id='submitForm'
                type='submit'
                value={''}
                className='hidden'
              />
            </RaytebForm>
          }
        ></Collapse>
      ) : (
        <RaytebForm
          checkIsRequired={true}
          className='relative md:max-w-md md:mx-auto'
          onSubmit={(e) => {
            appointmentList.reFetch({
              date: new Date(e.target['Date'].getAttribute('rayteb-value')),
              doctorServeShift: doctorServeShift?.key!,
              showPayed: e.target['showPayed'].checked,
              showReception: e.target['showReception'].checked,
              showVisit: e.target['showVisit'].checked,
              skip: 0,
              take: 100,
            })
          }}
        >
          <LoadingFit isLoading={appointmentList.isLoading} />
          <div className={classes['filter-row']}>
            <div className='col-span-5'>
              {!doctorServeShifts.isLoading &&
                doctorServeShifts.result &&
                doctorServeShifts.result?.length !== 0 ? (
                <TypeaheadText<DoctorShiftType>
                  innerText='همه (شیفت / خدمت)'
                  className='w-full h-9'
                  listData={doctorServeShifts.result}
                  fieldItem='value'
                  fieldValue='key'
                  value={doctorServeShifts.result?.find(
                    (n) => n.key === appointments.doctorServeShift
                  )}
                  selected={(e) => {
                    setDoctorServeShift(e)
                    setTimeout(() => {
                      document.getElementById('submitForm')?.click()
                    }, 300)
                  }}
                ></TypeaheadText>
              ) : (
                <>
                  {doctorServeShifts.isLoading ? (
                    <Skeleton className='!w-full h-9 rounded-lg' />
                  ) : (
                    <Select className='w-full h-9'>
                      <option value={''}>همه (شیفت / خدمت)</option>
                    </Select>
                  )}
                </>
              )}
            </div>
            <div className='col-span-5'>
              <DatePicker
                onChange={(e) => {
                  document.getElementById('submitForm')?.click()
                  setVisitDate(new Date(e.target.valueMiladi))
                }}
                innerText='تاریخ'
                isRequired={true}
                className='h-7 w-full'
                name='Date'
                value={appointments.dateShamsi || new Date().toShamsi()}
                raytebValue={appointments.dateMiladi || new Date()}
              />
            </div>
          </div>
          <div className={classes['filter-row']}>
            {center.centerConfigs?.find((n) => n.key === CenterConfigEnum.Queue)
              ?.value === 'True' ? (
              <>
                <div className='col-span-6'>
                  <TextBox
                    debounceTime={0}
                    className='w-full h-8 !text-xs'
                    innerText='جستجوی نام و نام خانوادگی ، کد ملی'
                    Type={TextBoxTypeEnum.Text}
                    onChange={(e) => {
                      const arr = e.target.value
                        .split(' ')
                        .map((n) => n.replace(' ', ''))
                      setSearchAppointment(arr)
                    }}
                  />
                </div>
                <div className='col-span-4 flex justify-center items-center gap-2'>
                  <TextBox
                    className=''
                    Type={TextBoxTypeEnum.Number}
                    innerText='شماره اتاق'
                    isReadOnly={true}
                    value={queue.roomNo?.toString()}
                  />
                  <Icon
                    icon='rayteb-edit'
                    className='text-xl text-warn'
                    onClick={() => {
                      setShowQueueInfoModal(true)
                    }}
                  />
                </div>
              </>
            ) : (
              <>
                <div className='col-span-10'>
                  <TextBox
                    debounceTime={0}
                    className='w-full h-8 !text-xs'
                    innerText='جستجوی نام و نام خانوادگی ، کد ملی'
                    Type={TextBoxTypeEnum.Text}
                    onChange={(e) => {
                      const arr = e.target.value
                        .split(' ')
                        .map((n) => n.replace(' ', ''))
                      setSearchAppointment(arr)
                    }}
                  />
                </div>
              </>
            )}
          </div>
          <div className={classes['filter-row-checkbox']}>
            <CheckBox
              onChange={(e) => document.getElementById('submitForm')?.click()}
              lable='پذیرش'
              className='text-xs !font-bold'
              name='showReception'
            />
            <CheckBox
              onChange={(e) => document.getElementById('submitForm')?.click()}
              lable='پرداخت'
              className='text-xs !font-bold'
              name='showPayed'
            />
            <CheckBox
              onChange={(e) => document.getElementById('submitForm')?.click()}
              lable='ویزیت'
              className='text-xs !font-bold'
              name='showVisit'
            />
            {/* <CheckBox
              onChange={(e) => document.getElementById('submitForm')?.click()}
              lable='مشاوره'
              className='text-xs !font-bold'
            /> */}
          </div>
          <input id='submitForm' type='submit' value={''} className='hidden' />
        </RaytebForm>
      )}
      {statisticsAppointment.result ? <div className='grid sm:grid-cols-4 xs:grid-cols-2 xs:gap-y-3 justify-items-center mt-5 sticky top-[89px] 
      z-10 bg-primaryDefault/40 py-2 backdrop-blur-sm '>
        <div className='pl-3 z-30'>
          <span className='p-1 text-xs text-primaryDark font-bold  '>{`تعداد پذیرش : ${statisticsAppointment.result?.totalComplete}`}</span>
        </div>
        <div className='pl-3 z-30'>
          <span className='p-1 text-xs text-primaryDark font-bold  '>{`تعداد پرداخت : ${statisticsAppointment.result?.totalPayed}`}</span>
        </div>
        <div className='pl-3 z-30'>
          <span className='p-1 text-xs text-primaryDark font-bold  '>{`تعداد ویزیت : ${statisticsAppointment.result?.totalVisited}`}</span>
        </div>
        <div className='pl-3 z-30'>
          <span className='p-1 text-xs text-primaryDark font-bold  '>{`تعداد کل : ${statisticsAppointment.result?.totalAll}`}</span>
        </div>
      </div> : <></>}
      <div className={classes['appointment-cards']}>
        {appointments.appointments
          ?.filter(
            (n) =>
              searchAppointment.some((x) =>
                n.firstName?.replace(' ', '').includes(x)
              ) ||
              searchAppointment.some((x) =>
                n.lastName?.replace(' ', '').includes(x)
              ) ||
              searchAppointment.some((x) =>
                n.code?.replace(' ', '').includes(x)
              )
          )
          .map((item, index) => {
            return (
              <AppointmentCard
                isEnableQueue={isEnableQueue}
                onCall={() => {
                  queueCall.reFetch(null, {
                    room: queue.roomNo!,
                    ticketId: item.ticketId!,
                  })
                  dispatch(setQueueTicket(item.ticketId))
                  if (queue.ticketId)
                    dispatch(pushPatientCalled({ ...appointments.appointments.find(x => x.ticketId === queue.ticketId) }))
                }}
                key={index}
                patient={deserveModal.data?.code!}
                appointment={{
                  ...item,
                  showDeserveModal(data) {
                    setDeserveModal({
                      ...deserveModal,
                      isOpen: true,
                      data: data,
                    })
                  },
                  isCounseling: !!item.appointmentType
                }}
                patientNotRegister={(data) => {
                  setGetForUnRegisterUserModal({
                    ...getForUnRegisterUserModal,
                    isOpen: true,
                    data: data,
                    ticketId: item.ticketId!
                  })
                }}
                setStartMeeting={() => {
                  setMeetingRequest.reFetch({ patientCode: item.code!, ticketId: item.ticketId!, isJoin: true })
                }}
              />
            )
          })}
        {appointments.appointmentCalled
          ?.filter(
            (n) =>
              searchAppointment.some((x) =>
                n.firstName?.replace(' ', '').includes(x)
              ) ||
              searchAppointment.some((x) =>
                n.lastName?.replace(' ', '').includes(x)
              ) ||
              searchAppointment.some((x) =>
                n.code?.replace(' ', '').includes(x)
              )
          )
          .map((item, index) => {
            return (
              <AppointmentCard
                isEnableQueue={isEnableQueue}
                isCalled={
                  QueueStateEnum[item.queueState!] ===
                  QueueStateEnum.DisplayedOnMonitor ||
                  QueueStateEnum[item.queueState!] === QueueStateEnum.Waiting ||
                  QueueStateEnum[item.queueState!] === QueueStateEnum.Called
                }
                isAbsent={
                  QueueStateEnum[item.queueState!] === QueueStateEnum.Absent
                }
                isCalledAgain={
                  QueueStateEnum[item.queueState!] === QueueStateEnum.Recall ||
                  (queue.ticketId === item.ticketId && !!item.queueState &&
                    QueueStateEnum[item.queueState!] !== QueueStateEnum.Absent)
                }
                onCall={() => {
                  queueCall.reFetch(null, {
                    room: queue.roomNo!,
                    ticketId: item.ticketId!,
                  })
                  dispatch(setQueueTicket(item.ticketId))

                  if (queue.ticketId)
                    dispatch(pushPatientCalled({ ...appointments.appointments.find(x => x.ticketId === queue.ticketId) }))
                }}
                key={index}
                patient={deserveModal.data?.code!}
                appointment={{
                  ...item,
                  showDeserveModal(data) {
                    setDeserveModal({
                      ...deserveModal,
                      isOpen: true,
                      data: data,
                    })
                  },
                }}
                patientNotRegister={(data) => {
                  setGetForUnRegisterUserModal({
                    ...getForUnRegisterUserModal,
                    isOpen: true,
                    data: data,
                    ticketId: item.ticketId!
                  })
                }}
                setStartMeeting={() => {
                  setMeetingRequest.reFetch({ patientCode: item.code!, ticketId: item.ticketId!, isJoin: true })
                }}
              />
            )
          })}
      </div>
      <MenuFooter>
        {center.centerConfigs?.find((n) => n.key === CenterConfigEnum.Queue)
          ?.value === 'True' ? (
          <>
            <Button
              onClick={() => {
                var appointmentValid = [...appointments.appointments].sort(function (a, b) {
                  return `${a.ticketNo}`.localeCompare(`${b.ticketNo}`)
                });

                if (appointmentValid.length === 0) {
                  toast.error('دیتایی وجود ندارد')
                  return
                }
                var index = appointmentValid.findIndex(
                  (n) => n.ticketId !== queue.ticketId &&
                    (QueueStateEnum[n.queueState!] === QueueStateEnum.Waiting ||
                      QueueStateEnum[n.queueState!] !== QueueStateEnum.TransfredToAnotherQueue)
                )

                if (index === -1) index = 0

                if (!appointmentValid[index]) {
                  toast.error('دیتایی وجود ندارد')
                  return
                }

                if (queue.ticketId)
                  dispatch(pushPatientCalled({ ...appointmentValid.find(x => x.ticketId === queue.ticketId) }))
                var ticket = appointmentValid[index]

                queueCall.reFetch(null, {
                  room: queue.roomNo!,
                  ticketId: ticket.ticketId!,
                })
                dispatch(setQueueTicket(ticket.ticketId!))

                setShowingPatient(true)

                Debounce({
                  func: () => {
                    setShowingPatient(false)
                  },
                  timeout: 1500,
                })
              }}
              className='!bg-primary text-white h-9 w-16 text-xs rounded-xl'
            >
              فراخوان
            </Button>
            <Button
              onClick={() => {
                var appointmentValid = appointments.appointmentCalled?.filter(
                  (n) => n.queueState
                )

                if (appointmentValid.length === 0 || !queue) {
                  toast.error('دیتایی وجود ندارد')
                  return
                }
                dispatch(pushPatientAbsent({ ...appointmentValid.find(x => x.ticketId === queue.ticketId) }))
                queueAbsent.reFetch(null, {
                  room: queue.roomNo!,
                  ticketId: queue.ticketId!,
                })
              }}
              className='!bg-danger  text-white h-9 w-16 text-xs rounded-xl'
            >
              غائب
            </Button>
          </>
        ) : (
          ''
        )}
        <Button
          className='!bg-secondary text-white h-9 w-24 text-xs rounded-xl'
          onClick={() => {
            setNewAppointment({ ...newAppointment, isOpen: true })
          }}
        >
          نوبت جدید
        </Button>
        <div
          className={`flex justify-center items-center text-white font-bold text-xs border-2 right-3
         border-warn  !transition-all ${showingPatient ? '!translate-x-0' : '!translate-x-[1000%]'
            }
        rounded-full w-12 h-12 bg-primaryDark absolute -top-[80%] left-[79%]`}
        >
          <span className='p-0'>
            {
              [
                ...appointments.appointmentCalled,
                ...appointments.appointments,
              ].find((n) => n.ticketId === queue.ticketId)?.ticketNo
            }
          </span>
        </div>
      </MenuFooter>

      <DeserveModal {...deserveModal} />
      <PartialDeserveModal {...partialDeserveModal} />
      <GetForUnRegisterUserModal {...getForUnRegisterUserModal} />
      <NewAppointmentModal
        option={newAppointment}
        doctorServeShifts={doctorServeShifts.result}
      />
      <QueueInfoModal
        open={showQueueInfoModal}
        hideModal={() => {
          setShowQueueInfoModal(false)
        }}
      />
    </>
  )
}
Appointment.GoToPage = ({ children }): ReactElement => {
  return <></>
}
export default Appointment
